import TitleBar from "@/components/ui/TitleBar";

const DashboardPage: React.FC = () => {
  return (
    <div className="mb-0">
      <TitleBar title="ダッシュボード" />
      <iframe
        title="ダッシュボード"
        src="/bi/superset/dashboard/voiceek/?standalone=2"
        style={{ border: "none", width: "100%", height: "100vh" }}
      />
    </div>
  );
};

export default DashboardPage;
